import { type ProductSliderBlockDTO, ListItemDiscriminator } from 'autogen/swagger/all';
import InlineButton from 'components/generic/InlineButton/InlineButton';
import { Typography } from 'components/generic/typography';
import styled, { css } from 'styled-components';
import { Spacing16, Spacing24, Spacing8 } from 'autogen/design-tokens/tokens';
import DynamicItemCarousel from 'components/generic/ScrollSnapSlider/components/DynamicItemCarousel';
import ProductItem from 'components/shared/productItem';
import { breakpoint, sizes } from 'variables';
import useIsMobile from 'hooks/responsive/useIsMobile';

const HeadingContainer = styled.div`
    display: grid;
    justify-content: center;
    margin-bottom: ${Spacing8};
`;

const scrollContainerStyling = css`
    && {
        gap: ${Spacing16};
        margin: 0 -${Spacing16};
        padding: 0 ${Spacing16};
        scroll-padding-inline-end: ${Spacing16};
        scroll-padding-inline-start: ${Spacing16};

        ${breakpoint.up(sizes.sm)} {
            gap: ${Spacing24};
        }

        ${breakpoint.up(sizes.xl)} {
            margin: 0;
            padding: 0;
            scroll-padding-inline-end: 0;
            scroll-padding-inline-start: 0;
        }
    }
`;

export default function CMSProductSlider({
    model: { headline, products, link, linkText }
}: {
    model: ProductSliderBlockDTO;
}) {
    const isMobile = useIsMobile();

    return (
        <div>
            <HeadingContainer>
                {headline && <Typography.Headline size="S">{headline}</Typography.Headline>}

                {link && (
                    <InlineButton size="sm" as="a" href={link}>
                        {linkText}
                    </InlineButton>
                )}
            </HeadingContainer>
            <DynamicItemCarousel
                gapSize={isMobile ? Spacing16 : Spacing24}
                items={products}
                itemRenderer={(itemModel) =>
                    ListItemDiscriminator(
                        itemModel,
                        () => null,
                        () => null,
                        (item) => <ProductItem model={item} key={item.id} />,
                        () => null
                    )
                }
                nextItemMobileIndentation="60px"
                scrollContainerCss={scrollContainerStyling}
            />
        </div>
    );
}
